import { Suspense, type ReactNode } from "react";
import { Loading } from "src/components/utils/Loading";

export const SettingsRouteBoundary = ({ children }: { children: ReactNode }) => (
    <Suspense fallback={<Loading />}>{children}</Suspense>
);
